// Page Names
export const LOGIN_PAGE = 'Login Page'
export const REGISTRATION_PAGE = 'Register'
export const INVITE_PAGE = 'Invite Page'
export const FORGOT_PASSWORD = 'Forgot Password'
export const PASSWORD_RESET = 'Password Reset'
export const MANAGE_MY_USER = 'Manage My User'
export const NEED_HELP = 'Help'
export const PRICING = 'Pricing'
export const PROSPECT_QUESTIONNAIRE = 'Prospect Questionnaire'

export const PRE_REGISTRATION_PAGE = 'Pre Register'
export const ADMIN_PROSPECTS = 'Prospects'
export const ADMIN_DASHBOARD = 'AdminDashboard'
export const ADMIN_ACCOUNTS = 'AdminAccounts'
export const ADMIN_ACCOUNT_USERS = 'AdminAccountUsers'
export const ADMIN_USERS = 'AdminUsers'
export const ADMIN_USER_DETAILS = 'AdminUserDetails'
export const ADMIN_BROKERAGES = 'AdminBrokerages'
export const ADMIN_BROKERAGE_DETAIL = 'Admin Brokerage Detail'
export const ADMIN_BROKERAGE_BILLING = 'Admin Brokerage Billing'
export const ADMIN_BROKERAGE_MGR = 'AdminAccountBrokerageManager'
export const ADMIN_BULK_ACCOUNT_UPLOAD = 'AdminBulkAccountUpload'
export const ADMIN_DELETE_ACCOUNT = 'AdminDeleteAccount'
export const ADMIN_API_USERS = 'AdminApiUsers'
export const ADMIN_ERRORS = 'AdminErrors'
export const ADMIN_WIZARD_FILES = 'AdminWizardFiles'
export const ADMIN_SCHEDULES = 'Admin Schedules'
export const ADMIN_SCHEDULE_RULES = 'Admin Schedule Rules'
export const ADMIN_RECENT_EVENTS = 'Admin Recent Events'
export const ADMIN_DOC_LIBRARY = 'Admin Doc Library'
export const ADMIN_BROADCAST = 'Admin Broadcast'
export const ADMIN_TEST_EMAIL = 'Admin Test Email'
export const ADMIN_TEST_ADDRESSES = 'Admin Test Addresses'
export const ADMIN_FEATURE_FLAG_REPORT = 'Feature Flag Report'

export const BROKER_ADMIN_SELECT = 'Brokerage Administration Selection'
export const BROKER_ADMIN = 'Brokerage Administration'
export const BROKER_CONFIG = 'Brokerage Configurations'
export const BROKER_ADMIN_USERS = 'Brokerage Admin Users'
export const BROKER_DATA = 'Brokerage Data'
export const BROKER_INVITE_PAGE = 'Brokerage Invite'
export const BROKER_BILLING = 'Brokerage Billing'
export const BROKER_APP_LIB = 'Brokerage App Library'
export const BROKER_ACCOUNTS = 'Brokerage Accounts'
export const BROKER_SCHEDULE_COLS = 'Brokerage Schedule Columns'
export const BROKER_SCHEDULE_EXPORT = 'Brokerage Schedule Export'
export const BROKER_PICTURES = 'Brokerage Pictures'

export const NOT_FOUND_PAGE = 'NotFoundPage'
export const SUBMISSION_DOWNLOAD = 'SubmissionDownload'

export const ACCOUNT = 'Account'
export const ACCOUNT_CONFIGURATION = 'Account Configuration'
export const COMMUNICATIONS = 'Communications'
export const COMMUNICATIONS_THREAD = 'Communications Thread'
export const ACCOUNT_SELECTOR = 'Account Selector'
export const ACCOUNT_DETAILS = 'Account Details'
export const ACCOUNT_CALENDAR = 'Account Calendar'
export const ACCOUNT_NOTIFICATIONS = 'Account Notifications'

export const ACCOUNT_MANAGEMENT = 'Account Management'
export const ACCOUNT_ACTIVITY = 'Account Activity'

// Path the Quotes
export const DASHBOARD = 'Dashboard'
export const RENEWAL_DASHBOARD = 'Renewal Dashboard'
export const DASHBOARD_RISK_MANAGEMENT = 'Dashboard Risk Management'
export const COMPANY_PROFILE = 'Company Profile'
export const COVERAGE_SELECTION = 'Coverage Selection'
export const COVERAGE_SUMMARY = 'Coverage Summary'
export const SCHEDULES = 'Schedule'
export const SCHEDULES_TYPED = 'Schedules'
export const POLICY_INFO = 'Policy Info'
export const APPLICATIONS = 'Applications'
export const APPLICATION_FORM = 'Application Form'
export const LOSS_RUNS = 'Loss Runs'
export const EXPERIENCE_MOD = 'Experience Mod'
export const FINANCIALS = 'Financials'
export const UNDERWRITING_DOCUMENTS = 'Underwriting Documents'
export const SUBMIT_TO_ACCOUNT_MANAGER = 'Submit to Advisor'
export const DOCUMENTS = 'Documents'
export const PDF_VIEW = 'PDF View'
export const PAYMENT = 'Payment'
export const ALPS_PAYMENT = 'Alps Payment'
export const BILLING_HISTORY = 'Billing History'
export const UPDATE_FIRM = 'Update Firm'
export const CERT_HOLDERS = 'Certificate Holders'

// Account Routes

export const NEW_CLAIM_PORTAL = 'New Claim Portal'
export const CREATE_CLAIM_PORTAL = 'Create Claim'
export const CERT_OF_INSURANCE_REQUEST = 'Certificate Request'
export const ACCOUNT_STAGING = 'Account Staging'

// Profile Routes
export const PROFILE_ENTITY = 'Entity Info'
export const PROFILE_GENERAL = 'General Info'
export const PROFILE_NAMED_INSUREDS = 'Named Insureds'
export const PROFILE_SAFETY = 'Safety & Loss Control'
export const PROFILE_SUPPORTING_FILES = 'Supporting Files'
export const PROFILE_INDUSTRY = 'Industry Questions'

// Risk Management
export const CERT_OF_INSURANCE = 'Certificates of Insurance'
export const EVIDENCE_PROP_INSURANCE = 'Evidence of Property Insurance'
export const AUDIT = 'Audit'
export const SAFETY_PORTAL = 'Safety Portal'
export const CLAIM_PORTAL = 'Claim Portal'
export const NCCI = 'NCCI'
export const OSHA = 'OSHA'
export const HR = 'HR'
export const BILLING = 'Billing'
export const AUTO_ID_CARDS = 'Auto Id Cards'
export const BR_APPLICATIONS = "Builder's Risk App"
export const BR_REPORT = "Builder's Risk Report"
export const BR_QUOTE = "Builder's Risk Quotes"
export const RISK_REGULATORY = 'Risk Regulatory'
export const RISK_COMPLIANCE = 'Risk Compliance'

// Builders Risk
export const BUILDERS_RISK_PROJECTS = 'Builders Risk Projects'
export const BUILDERS_RISK_PROJECT_VIEW = 'Builders Risk Project View'
export const BUILDERS_RISK_BUILDING_VIEW = 'Builders Risk Building View'

// Forms
export const FORM_LAYOUT_EDITOR = 'Form Layout Editor'
export const FORM_LAYOUT_EDITOR_BROKERAGE = 'Form Layout Editor Propagate'
export const FORM_BROKER_LAYOUTS = 'Form Broker Layouts'
export const FORM_LAYOUT_VIEWER = 'Form Layout Viewer'
export const FORM_LAYOUT_VIEWER_DETAIL = 'Form Layout Detail'

// Policies
export const POLICY_ADMIN = 'Policy Administration'
export const POLICY_DETAIL = 'Policy Detail'
export const POLICY_DETAIL_EXTERNAL = 'Policy Detai External'
export const PREMIUM_SUMMARY = 'Premium Summary'
export const ENDORSEMENTS = 'Endorsements'
export const PROPOSALS = 'Proposals'
export const ALLOCATIONS = 'Allocations'
export const INSURANCE_VS_MARKET = 'Insurance to Loan'
export const INSURANCE_TO_LOAN_BID = 'Insurance to Loan Bid'

// Advisor Routes
export const ADVISOR_APP_CYCLE = 'Advisor App Cycle'

export const INSURICA_NEW_BUSINESS_FLOW = 'Insurica New Business'
export const INTERNAL_QUOTE_REVIEW = 'Internal Quote Review'
export const SUBJECTIVITIES = 'Subjectivities'
export const QUOTE_REVIEW = 'Quote Review'
export const BIND_DECISION = 'Bind Decision'
export const POLICY_SELECTION = 'Policy Selection'
export const INSURICA_DASHBOARD = 'Insurica Dashboard'

export const BROKER_OF_RECORD = 'Broker of Record'

export const BROKER_OF_RECORD_CREATE = 'New Broker of Recorde'

// Highwing Demo
export const DATA_REQUEST_SELECTOR = 'Data Request Select'
export const HIGHWING_DEMO_ROUTE = 'Highwing'
export const HIGHWING_DEMO_USER_ROUTE = 'Highwing Demo'
export const DATA_REQUEST = 'Data Request'
export const DATA_REQUEST_USER = 'Data Request Demo'

export const USER_SIGNATURE = 'UserSignature'
export const SIGNATURE = 'Signature'

export const PREPARE_FOR_SIGNING = 'Prepare for Signing'

export const SIGNATURE_REQUESTS = 'Signature Requests'

export const PDF_EDITOR = 'PDF Editor'
export const PDF_FIELDS_COPY = 'PDF Fields Copy'

export const RESOURCE_NOT_FOUND = 'Resource Not Found'

export const FORBIDDEN = 'Forbidden'

// Attorney flow
export const ATTORNEYS = 'Attorneys'
export const OPEN_APPS_LANDING = 'Open Applications'
export const OPEN_APPS_FORM = 'Open Applications Form'
